export default {
  UPLOADER_TEXT: 'Arrastra y suelta',
  BUTTON_LABEL: 'Explora los archivos',
}
